import { createTheme } from 'react-data-table-component'

createTheme(
    'rackemm_theme',
    {
        text: {
            primary: '#00ffff',
            secondary: '#2aa198',
        },
        background: {
            default: '#525559',
        },
        // context: {
        //     background: '#cb4b16',
        //     text: '#FFFFFF',
        // },
        divider: {
            default: '#373b3e',
        },
        // action: {
        //     button: 'rgba(0,0,0,.54)',
        //     hover: 'rgba(0,0,0,.08)',
        //     disabled: 'rgba(0,0,0,.12)',
        // },
    },
    'dark',
)

createTheme(
    'rackemm_theme_admin',
    {
        text: {
            primary: '#00ffff',
            secondary: '#2aa198',
        },
        background: {
            default: '#525559',
        },
        // context: {
        //     background: '#cb4b16',
        //     text: '#FFFFFF',
        // },
        divider: {
            default: '#373b3e',
        },
        // action: {
        //     button: 'rgba(0,0,0,.54)',
        //     hover: 'rgba(0,0,0,.08)',
        //     disabled: 'rgba(0,0,0,.12)',
        // },
    },
    'dark',
)
